import React from 'react';
import BaseParameters from '..';

function PayorMixParameters() {
    return (
        <BaseParameters paramGroup="Payer Mix Parameters"/>
    );
}

export default PayorMixParameters;
